import React, { useEffect, useState } from "react";
import "./AddTeamForm.css";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import TextArea from "../../../Atoms/Inputs/TextArea/TextArea";
import useEdit from "../../../../Hooks/useEdit";
import useSave from "../../../../Hooks/useSave";
import TextFieldInput from "../../../Atoms/Inputs/TextField/TextFieldInput";
import { Formik } from "formik";
import * as Yup from "yup";
import { PhoneInput } from "react-international-phone";
import { MuiTelInput } from "mui-tel-input";
import { phone } from "phone";
import { images } from "../../../../Assets/assetsHelper";
import CloseIcon from "@mui/icons-material/Close";
import useFetchWhen from "../../../../Hooks/useFetchWhen";
import useFetch from "../../../../Hooks/useFetch";
import { Height } from "@mui/icons-material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  categoriesURL,
  coachesURL,
  membersURL,
  teamsURL,
} from "../../../../Hooks/URL";
import AddMemberForm from "../AddMemberForm/AddMemberForm";
import AddCoachForm from "../AddCoachForm/AddCoachForm";
import FormModal from "../../../Molecules/FormModal/FormModal";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import config from "../../../../config";

const TeamSchema = Yup.object().shape({
  name: Yup.string().required("Team name is required!"),
  categoryId: Yup.string().required("Category is required!"),
  ageGroupId: Yup.string().required("Age group is required!"),
  coachId: Yup.string().required("Coach required !!"),
  participantIn: Yup.string().required("Please choose competition !!"),
});

const WeDoTeamSchema = Yup.object().shape({
  name: Yup.string().required("Team name is required!"),
  categoryId: Yup.string().required("Category is required!"),
  ageGroupId: Yup.string().required("Age group is required!"),
  coachId: Yup.string().required("Coach required !!"),
});

function AddTeamForm({
  Edit = false,
  team,
  url,
  setTeam,
  setTeams,
  setOpen,
  page,
  search,
  setOpenCoach,
  setOpenMember,
  OpenCoach,
  OpenMember,
  editId,
  editType,
}) {
  const [coaches, setCoaches] = useState([]);
  const [coachesUpdate, setCoachesUpdate] = useState(true);
  const [members, setMembers] = useState([]);
  const [membersUpdate, setMembersUpdate] = useState(true);
  const {
    data: categoriesData,
    loading: categoriesLoading,
    error: categoriesError,
  } = useFetch(`${categoriesURL}/withAgeGroups`);
  const {
    data: membersData,
    loading: membersLoading,
    error: membersError,
  } = useFetchWhen(
    `${membersURL}/forAssignToTeam`,
    members?.length == 0 && membersUpdate
  );
  const {
    data: coachesData,
    loading: coachesLoading,
    error: coachesError,
  } = useFetchWhen(
    `${coachesURL}/forAssignToTeam`,
    coaches.length == 0 && coachesUpdate
  );

  useEffect(() => {
    if (coachesData?.data) {
      setCoaches(coachesData?.data);
      setCoachesUpdate(false);
    }
  }, [coachesData]);

  useEffect(() => {
    if (membersData?.data) {
      setMembers(membersData?.data);
      setMembersUpdate(false);
    }
  }, [membersData]);

  const [membersCh, setMembersCh] = useState(
    team?.members?.map((mem) => ({ ...mem, valid: true })) ?? []
  );
  const [membersErrorMsg, setMembersErrorMsg] = useState(
    "Team must have at least 1 member !!"
  );
  const [membersTouched, setMembersTouched] = useState(false);

  useEffect(() => {
    if (membersTouched)
      if (
        (config.APP_NAME == "Code Reg" && membersCh?.length > 3) ||
        (config.APP_NAME == "WeDo Reg" && membersCh?.length > 5)
      )
        setMembersErrorMsg(
          `Team must have only ${
            config.APP_NAME == "Code Reg" ? 3 : 5
          } members !!`
        );
      else if (
        (config.APP_NAME == "Code Reg" && membersCh?.length < 1) ||
        (config.APP_NAME == "WeDo Reg" && membersCh?.length < 2)
      )
        setMembersErrorMsg(
          `Team must have at least ${
            config.APP_NAME == "Code Reg" ? 1 : 2
          } member !!`
        );
      else setMembersErrorMsg("");
  }, [membersCh]);

  const [newObject, setNewObject] = useState({});
  const [goEdit, setGoEdit] = useState(false);
  const [goSave, setGoSave] = useState(false);
  const { state, loading: editLoading } = useEdit(
    editType == "members"
      ? `${teamsURL}/${editId}/members`
      : `${teamsURL}/${editId}`,
    goEdit,
    setGoEdit,
    newObject,
    -1
  );

  const {
    saveState,
    loading: addLoading,
    newData,
  } = useSave({
    url: teamsURL,
    goSave,
    setGoSave,
    newObject,
    navigateAfter: "/teams",
  });

  useEffect(() => {
    if (state.dataRes.status == "success") {
      // setOpen(false);
      // navigate()
    }
  }, [state]);

  useEffect(() => {
    if (saveState.dataRes.status == "success") {
      // setOpen(false);
      // navigate()
    }
  }, [saveState]);

  return (
    <div className="SmallFormWrapper">
      <FormModal
        Open={OpenCoach}
        HandleClose={() => {
          setOpenCoach(false);
        }}
        Form={
          <AddCoachForm
            url={coachesURL}
            navigateafter={false}
            setOpen={setOpenCoach}
            setCoaches={setCoaches}
            setCoachesUpdate={setCoachesUpdate}
          />
        }
        Title={"Add New Coach"}
      />
      <FormModal
        Open={OpenMember}
        HandleClose={() => {
          setOpenMember(false);
        }}
        Form={
          <AddMemberForm
            url={membersURL}
            navigateafter={false}
            setOpen={setOpenMember}
            setMembers={setMembers}
            setMembersUpdate={setMembersUpdate}
          />
        }
        Title={"Add New Member"}
      />
      <Formik
        initialValues={
          config.APP_NAME == "Code Reg"
            ? {
                name: team?.name ?? "",
                categoryId: team?.category?.id ?? "",
                ageGroupId: team?.ageGroup?.id ?? "",
                coachId: team?.coach?.id ?? "",
                participantIn:
                  team?.onlineParticipant && team?.offlineParticipant
                    ? "both"
                    : team?.onlineParticipant
                    ? "online"
                    : team?.offlineParticipant
                    ? "offline"
                    : "",
              }
            : {
                name: team?.name ?? "",
                categoryId: team?.category?.id ?? "",
                ageGroupId: team?.ageGroup?.id ?? "",
                coachId: team?.coach?.id ?? "",
              }
        }
        validationSchema={
          config.APP_NAME == "Code Reg" ? TeamSchema : WeDoTeamSchema
        }
        onSubmit={(values) => {
          if (team) {
            if (editType == "details") {
              const prev =
                config.APP_NAME == "Code Reg"
                  ? {
                      name: team?.name ?? "",
                      categoryId: team?.category?.id ?? "",
                      ageGroupId: team?.ageGroup?.id ?? "",
                      coachId: team?.coach?.id ?? "",
                      participantIn: team?.participantIn ?? "",
                    }
                  : {
                      name: team?.name ?? "",
                      categoryId: team?.category?.id ?? "",
                      ageGroupId: team?.ageGroup?.id ?? "",
                      coachId: team?.coach?.id ?? "",
                    };
              setNewObject(
                Object.fromEntries(
                  Object.entries({
                    ...prev,
                    ...values,
                  }).filter(([key]) => prev[key] != values[key])
                )
              );
              setGoEdit(true);
            } else {
              if (!membersErrorMsg) {
                const prevMembers = team?.members ?? [];
                let userFinalChoices = membersCh?.map((member) => member?.id);
                let newMembers = userFinalChoices.filter(
                  (id) => !prevMembers.some((member) => member.id === id)
                );
                let deletedMembers = prevMembers
                  .filter((member) => !userFinalChoices.includes(member.id))
                  .map((member) => member.id);
                setNewObject({
                  addedMembersIds: newMembers,
                  deletedMembersIds: deletedMembers,
                });
                setGoEdit(true);
              } else setMembersTouched(true);
            }
          } else {
            if (!membersErrorMsg) {
              setNewObject({
                ...values,
                membersIds: membersCh?.map((member) => member?.id),
              });
              setGoSave(true);
            } else setMembersTouched(true);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form autoComplete="off" onSubmit={handleSubmit}>
            {!Edit || (Edit && editType == "details") ? (
              <div className="FormContainer">
                <div className="LeftForm">
                  <TextFieldInput
                    fullWidth
                    type="text"
                    placeholder={"Enter Team Name"}
                    className="Input"
                    label={"Team Name"}
                    name={"name"}
                    change={handleChange}
                    blur={handleBlur}
                    newValue={values.name}
                  />
                  {errors.name && touched.name && (
                    <p className="error">{errors.name}</p>
                  )}
                  <TextFieldInput
                    select
                    newValue={values?.categoryId}
                    placeholder={"Choose Team Category"}
                    name={"categoryId"}
                    change={(e) => {
                      setMembersCh([]);
                      handleChange({
                        target: {
                          name: "categoryId",
                          value: e.target.value,
                        },
                      });
                      handleChange({
                        target: {
                          name: "ageGroupId",
                          value: "",
                        },
                      });
                      handleChange({
                        target: {
                          name: "membersIds",
                          value: [],
                        },
                      });
                    }}
                    blur={handleBlur}
                    fullWidth
                    className={`Input`}
                    variant="outlined"
                    SelectProps={{
                      displayEmpty: true,
                    }}
                  >
                    <MenuItem value="" className="" disabled>
                      Choose Team Category
                    </MenuItem>
                    {categoriesData?.data?.map((item, i) => (
                      <MenuItem value={item?.id} key={i}>
                        {item?.name}
                      </MenuItem>
                    ))}
                  </TextFieldInput>
                  {errors.categoryId && touched.categoryId && (
                    <p className="error">{errors.categoryId}</p>
                  )}
                </div>
                <Box
                  className="RightForm"
                  sx={{
                    display: "flex !important",
                    flexDirection: { xs: "column-reverse", lg: "column" },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <TextFieldInput
                        select
                        newValue={values?.coachId}
                        placeholder={"Choose Team's Coach"}
                        name={"coachId"}
                        change={(e) => {
                          handleChange({
                            target: {
                              name: "coachId",
                              value: e.target.value,
                            },
                          });
                        }}
                        blur={handleBlur}
                        fullWidth
                        className={`Input`}
                        variant="outlined"
                        SelectProps={{
                          displayEmpty: true,
                        }}
                      >
                        <MenuItem value="" className="" disabled>
                          Choose Team's Coach
                        </MenuItem>
                        {coaches?.map((item, i) => (
                          <MenuItem value={item?.id} key={i}>
                            {item?.name}
                          </MenuItem>
                        ))}
                      </TextFieldInput>
                      {errors.coachId && touched.coachId && (
                        <p className="error">{errors.coachId}</p>
                      )}
                    </div>
                    <PrimaryButton
                      classBtn={"center"}
                      btnType={"button"}
                      text={"Add New"}
                      style={{
                        textTransform: "capitalize",
                        borderRadius: "50%",
                        color: config.SECONDARY_COLOR,
                        backgroundColor: config.PRIMARY_COLOR,
                        marginLeft: "10px",
                        height: "45px",
                        width: "100%",
                        maxWidth: "100px",
                        borderRadius: "5px",
                      }}
                      click={() => setOpenCoach(true)}
                    />
                    {/* <PrimaryButton
                      classBtn={"center plusButton"}
                      btnType={"button"}
                      text={<AddCircleOutlineIcon />}
                      style={{
                        textTransform: "capitalize",
                        borderRadius: "50%",
                        color: config.SECONDARY_COLOR,
                        backgroundColor: config.PRIMARY_COLOR,
                        marginLeft: "10px",
                        height: "45px",
                        width: "45px",
                        minWidth: "45px",
                      }}
                      click={() => setOpenCoach(true)}
                    /> */}
                  </Box>
                  <TextFieldInput
                    select
                    newValue={values?.ageGroupId}
                    placeholder={"Choose Age Group"}
                    name={"ageGroupId"}
                    change={(e) => {
                      setMembersCh([]);
                      handleChange({
                        target: {
                          name: "ageGroupId",
                          value: e.target.value,
                        },
                      });
                      handleChange({
                        target: {
                          name: "membersIds",
                          value: [],
                        },
                      });
                    }}
                    blur={handleBlur}
                    fullWidth
                    className={`Input`}
                    variant="outlined"
                    SelectProps={{
                      displayEmpty: true,
                    }}
                  >
                    <MenuItem value="" className="" disabled>
                      Choose Age Group
                    </MenuItem>
                    {categoriesData?.data
                      ?.find((cat) => cat?.id == values?.categoryId)
                      ?.ageGroups?.map((item, i) => (
                        <MenuItem value={item?.id} key={i}>
                          {item?.name} ( {item?.minAge} - {item?.maxAge} years )
                        </MenuItem>
                      ))}
                  </TextFieldInput>
                  {errors.ageGroupId && touched.ageGroupId && (
                    <p className="error">{errors.ageGroupId}</p>
                  )}
                </Box>
              </div>
            ) : (
              ""
            )}

            {(!Edit || (Edit && editType == "details")) &&
            config.APP_NAME == "Code Reg" ? (
              <>
                <FormControl
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: { xs: "flex-start", md: "center" },
                    marginLeft: { xs: "0", md: "10px" },
                    marginBottom: { xs: "5px", md: "0" },
                    marginTop: { xs: "5px", md: "0" },
                  }}
                >
                  <FormLabel id="participantIn">Participate in:</FormLabel>
                  <RadioGroup
                    aria-labelledby="participantIn"
                    name="participantIn"
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      marginLeft: "10px",
                    }}
                    onChange={handleChange}
                    value={values?.participantIn}
                  >
                    <FormControlLabel
                      value="online"
                      control={<Radio />}
                      label="Online"
                    />
                    <FormControlLabel
                      value="offline"
                      control={<Radio />}
                      label="Offline"
                    />
                    <FormControlLabel
                      value="both"
                      control={<Radio />}
                      label="Both (online & offline)"
                    />
                  </RadioGroup>
                </FormControl>
                {errors.participantIn && touched.participantIn && (
                  <p className="error">{errors.participantIn}</p>
                )}
              </>
            ) : (
              ""
            )}
            {!Edit || (Edit && editType == "members") ? (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "100%", transition: "0s" }}>
                    <Autocomplete
                      multiple
                      options={
                        values?.ageGroupId
                          ? members?.map((mem) => ({
                              ...mem,
                              valid: dayjs(mem?.birthday).isBetween(
                                dayjs(
                                  categoriesData?.data
                                    ?.find(
                                      (cat) => cat?.id == values?.categoryId
                                    )
                                    ?.ageGroups?.find(
                                      (age) => age?.id == values?.ageGroupId
                                    )?.minBirthday
                                ),
                                dayjs(
                                  categoriesData?.data
                                    ?.find(
                                      (cat) => cat?.id == values?.categoryId
                                    )
                                    ?.ageGroups?.find(
                                      (age) => age?.id == values?.ageGroupId
                                    )?.maxBirthday
                                ),
                                "day",
                                "[]"
                              )
                                ? true
                                : false,
                            })) ?? []
                          : []
                      }
                      getOptionLabel={(option) =>
                        `${option?.name}${
                          team
                            ? option?.joinedToTeam &&
                              !team?.members?.some((te) => te?.id == option?.id)
                              ? " - Already joined another team"
                              : !option?.valid
                              ? " - Not valid in this age group"
                              : ""
                            : option?.joinedToTeam
                            ? " - Already joined another team"
                            : !option?.valid
                            ? " - Not valid in this age group"
                            : ""
                        }`
                      }
                      filterOptions={(options) =>
                        options?.filter(
                          (item) => !membersCh?.some((el) => el?.id == item?.id)
                        )
                      }
                      getOptionDisabled={(option) =>
                        team
                          ? !option?.valid ||
                            (option?.joinedToTeam &&
                              !team?.members?.some(
                                (te) => te?.id == option?.id
                              ))
                          : !option?.valid || option?.joinedToTeam
                      }
                      value={membersCh}
                      name={"membersIds"}
                      className="chooseStudents"
                      onChange={(e, newValue) => {
                        setMembersTouched(true);
                        setMembersCh(newValue);
                      }}
                      renderInput={(params) => (
                        <TextFieldInput
                          {...params}
                          label="Choose Team Members"
                          placeholder="Members"
                          className={`Input`}
                          styles={{ width: "100%" }}
                          name={"membersIds"}
                          Required={false}
                        />
                      )}
                    />
                    {membersErrorMsg && membersTouched && (
                      <p className="error">{membersErrorMsg}</p>
                    )}
                  </div>
                  <PrimaryButton
                    classBtn={"center"}
                    btnType={"button"}
                    text={"Add New"}
                    style={{
                      textTransform: "capitalize",
                      borderRadius: "50%",
                      color: config.SECONDARY_COLOR,
                      backgroundColor: config.PRIMARY_COLOR,
                      marginLeft: "10px",
                      height: "45px",
                      width: "100%",
                      maxWidth: "100px",
                      borderRadius: "5px",
                    }}
                    click={() => setOpenMember(true)}
                  />
                </Box>
                {!Edit ? (
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", md: "14px" },
                    }}
                  >
                    <strong>Note:</strong> You must select a coach and team
                    member. If no coach or team member is available, click the
                    red button to add a new one.
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", md: "14px" },
                    }}
                  >
                    <strong>Note:</strong> You must select team member. If no
                    team member is available, click the red button to add a new
                    one.
                  </Typography>
                )}
              </>
            ) : (
              <></>
            )}

            <div style={{ display: "flex", justifyContent: "center" }}>
              <PrimaryButton
                classBtn={"center"}
                btnType={"submit"}
                text={Edit ? "Edit" : "Add"}
                loading={Edit ? editLoading : addLoading}
                style={{
                  textTransform: "capitalize",
                  marginTop: "15px",
                  width: "160px",
                  borderRadius: "5px",
                  color: config.SECONDARY_COLOR,
                  backgroundColor: config.PRIMARY_COLOR,
                }}
              />
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default AddTeamForm;
